{
  "v": "5.7.4",
  "fr": 15,
  "ip": 0,
  "op": 72,
  "w": 220,
  "h": 32,
  "nm": "LOADING_font",
  "ddd": 0,
  "assets": [],
  "fonts": { "list": [{ "fName": "BodoniSvtyTwoITCTT-Book", "fFamily": "Bodoni 72", "fStyle": "Book", "ascent": 71.3985473727807 }] },
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 5,
      "nm": "L 3",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 36, "s": [0] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 42, "s": [100] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 59, "s": [100] },
            { "t": 64, "s": [0] }
          ],
          "ix": 11
        },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [27.5, 26.5, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "t": {
        "d": {
          "k": [
            {
              "s": { "s": 32, "f": "BodoniSvtyTwoITCTT-Book", "t": "L", "j": 2, "tr": 250, "lh": 38.4, "ls": 0, "fc": [0.067, 0.067, 0.067], "sc": [0.067, 0.067, 0.067], "sw": 0.5, "of": true },
              "t": 0
            }
          ]
        },
        "p": {},
        "m": { "g": 1, "a": { "a": 0, "k": [0, 0], "ix": 2 } },
        "a": []
      },
      "ip": 36,
      "op": 72,
      "st": 27,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 2,
      "ty": 5,
      "nm": "O 3",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 37, "s": [0] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 43, "s": [100] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 60, "s": [100] },
            { "t": 65, "s": [0] }
          ],
          "ix": 11
        },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [54.5, 26.5, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "t": {
        "d": {
          "k": [
            {
              "s": { "s": 32, "f": "BodoniSvtyTwoITCTT-Book", "t": "O", "j": 2, "tr": 250, "lh": 38.4, "ls": 0, "fc": [0.067, 0.067, 0.067], "sc": [0.067, 0.067, 0.067], "sw": 0.5, "of": true },
              "t": 0
            }
          ]
        },
        "p": {},
        "m": { "g": 1, "a": { "a": 0, "k": [0, 0], "ix": 2 } },
        "a": []
      },
      "ip": 36,
      "op": 72,
      "st": 27,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 3,
      "ty": 5,
      "nm": "A 3",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 38, "s": [0] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 44, "s": [100] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 61, "s": [100] },
            { "t": 66, "s": [0] }
          ],
          "ix": 11
        },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [81.5, 26.5, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "t": {
        "d": {
          "k": [
            {
              "s": { "s": 32, "f": "BodoniSvtyTwoITCTT-Book", "t": "A", "j": 2, "tr": 250, "lh": 38.4, "ls": 0, "fc": [0.067, 0.067, 0.067], "sc": [0.067, 0.067, 0.067], "sw": 0.5, "of": true },
              "t": 0
            }
          ]
        },
        "p": {},
        "m": { "g": 1, "a": { "a": 0, "k": [0, 0], "ix": 2 } },
        "a": []
      },
      "ip": 36,
      "op": 72,
      "st": 27,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 4,
      "ty": 5,
      "nm": "D 3",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 39, "s": [0] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 45, "s": [100] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 62, "s": [100] },
            { "t": 67, "s": [0] }
          ],
          "ix": 11
        },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [109.5, 26, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "t": {
        "d": {
          "k": [
            {
              "s": { "s": 32, "f": "BodoniSvtyTwoITCTT-Book", "t": "D", "j": 2, "tr": 250, "lh": 38.4, "ls": 0, "fc": [0.067, 0.067, 0.067], "sc": [0.067, 0.067, 0.067], "sw": 0.5, "of": true },
              "t": 0
            }
          ]
        },
        "p": {},
        "m": { "g": 1, "a": { "a": 0, "k": [0, 0], "ix": 2 } },
        "a": []
      },
      "ip": 36,
      "op": 72,
      "st": 27,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 5,
      "ty": 5,
      "nm": "I 3",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 40, "s": [0] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 46, "s": [100] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 63, "s": [100] },
            { "t": 68, "s": [0] }
          ],
          "ix": 11
        },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [133, 26.5, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "t": {
        "d": {
          "k": [
            {
              "s": { "s": 32, "f": "BodoniSvtyTwoITCTT-Book", "t": "I", "j": 2, "tr": 250, "lh": 38.4, "ls": 0, "fc": [0.067, 0.067, 0.067], "sc": [0.067, 0.067, 0.067], "sw": 0.5, "of": true },
              "t": 0
            }
          ]
        },
        "p": {},
        "m": { "g": 1, "a": { "a": 0, "k": [0, 0], "ix": 2 } },
        "a": []
      },
      "ip": 36,
      "op": 72,
      "st": 27,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 6,
      "ty": 5,
      "nm": "N 3",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 41, "s": [0] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 48, "s": [100] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 64, "s": [100] },
            { "t": 69, "s": [0] }
          ],
          "ix": 11
        },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [157, 26.5, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "t": {
        "d": {
          "k": [
            {
              "s": { "s": 32, "f": "BodoniSvtyTwoITCTT-Book", "t": "N", "j": 2, "tr": 250, "lh": 38.4, "ls": 0, "fc": [0.067, 0.067, 0.067], "sc": [0.067, 0.067, 0.067], "sw": 0.5, "of": true },
              "t": 0
            }
          ]
        },
        "p": {},
        "m": { "g": 1, "a": { "a": 0, "k": [0, 0], "ix": 2 } },
        "a": []
      },
      "ip": 36,
      "op": 72,
      "st": 27,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 7,
      "ty": 5,
      "nm": "G 3",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 43, "s": [0] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 52, "s": [100] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 64, "s": [100] },
            { "t": 69, "s": [0] }
          ],
          "ix": 11
        },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [184.5, 26.5, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "t": {
        "d": {
          "k": [
            {
              "s": { "s": 32, "f": "BodoniSvtyTwoITCTT-Book", "t": "G", "j": 2, "tr": 250, "lh": 38.4, "ls": 0, "fc": [0.067, 0.067, 0.067], "sc": [0.067, 0.067, 0.067], "sw": 0.5, "of": true },
              "t": 0
            }
          ]
        },
        "p": {},
        "m": { "g": 1, "a": { "a": 0, "k": [0, 0], "ix": 2 } },
        "a": []
      },
      "ip": 36,
      "op": 72,
      "st": 27,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 8,
      "ty": 5,
      "nm": "L 2",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 0, "s": [0] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 6, "s": [100] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 23, "s": [100] },
            { "t": 28, "s": [0] }
          ],
          "ix": 11
        },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [27.5, 26.5, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "t": {
        "d": {
          "k": [
            {
              "s": { "s": 32, "f": "BodoniSvtyTwoITCTT-Book", "t": "L", "j": 2, "tr": 250, "lh": 38.4, "ls": 0, "fc": [0.067, 0.067, 0.067], "sc": [0.067, 0.067, 0.067], "sw": 0.5, "of": true },
              "t": 0
            }
          ]
        },
        "p": {},
        "m": { "g": 1, "a": { "a": 0, "k": [0, 0], "ix": 2 } },
        "a": []
      },
      "ip": 0,
      "op": 36,
      "st": -9,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 9,
      "ty": 5,
      "nm": "O 2",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 1, "s": [0] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 7, "s": [100] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 24, "s": [100] },
            { "t": 29, "s": [0] }
          ],
          "ix": 11
        },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [54.5, 26.5, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "t": {
        "d": {
          "k": [
            {
              "s": { "s": 32, "f": "BodoniSvtyTwoITCTT-Book", "t": "O", "j": 2, "tr": 250, "lh": 38.4, "ls": 0, "fc": [0.067, 0.067, 0.067], "sc": [0.067, 0.067, 0.067], "sw": 0.5, "of": true },
              "t": 0
            }
          ]
        },
        "p": {},
        "m": { "g": 1, "a": { "a": 0, "k": [0, 0], "ix": 2 } },
        "a": []
      },
      "ip": 0,
      "op": 36,
      "st": -9,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 10,
      "ty": 5,
      "nm": "A 2",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 2, "s": [0] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 8, "s": [100] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 25, "s": [100] },
            { "t": 30, "s": [0] }
          ],
          "ix": 11
        },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [81.5, 26.5, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "t": {
        "d": {
          "k": [
            {
              "s": { "s": 32, "f": "BodoniSvtyTwoITCTT-Book", "t": "A", "j": 2, "tr": 250, "lh": 38.4, "ls": 0, "fc": [0.067, 0.067, 0.067], "sc": [0.067, 0.067, 0.067], "sw": 0.5, "of": true },
              "t": 0
            }
          ]
        },
        "p": {},
        "m": { "g": 1, "a": { "a": 0, "k": [0, 0], "ix": 2 } },
        "a": []
      },
      "ip": 0,
      "op": 36,
      "st": -9,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 11,
      "ty": 5,
      "nm": "D 2",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 3, "s": [0] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 9, "s": [100] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 26, "s": [100] },
            { "t": 31, "s": [0] }
          ],
          "ix": 11
        },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [109.5, 26, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "t": {
        "d": {
          "k": [
            {
              "s": { "s": 32, "f": "BodoniSvtyTwoITCTT-Book", "t": "D", "j": 2, "tr": 250, "lh": 38.4, "ls": 0, "fc": [0.067, 0.067, 0.067], "sc": [0.067, 0.067, 0.067], "sw": 0.5, "of": true },
              "t": 0
            }
          ]
        },
        "p": {},
        "m": { "g": 1, "a": { "a": 0, "k": [0, 0], "ix": 2 } },
        "a": []
      },
      "ip": 0,
      "op": 36,
      "st": -9,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 12,
      "ty": 5,
      "nm": "I 2",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 4, "s": [0] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 10, "s": [100] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 27, "s": [100] },
            { "t": 32, "s": [0] }
          ],
          "ix": 11
        },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [133, 26.5, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "t": {
        "d": {
          "k": [
            {
              "s": { "s": 32, "f": "BodoniSvtyTwoITCTT-Book", "t": "I", "j": 2, "tr": 250, "lh": 38.4, "ls": 0, "fc": [0.067, 0.067, 0.067], "sc": [0.067, 0.067, 0.067], "sw": 0.5, "of": true },
              "t": 0
            }
          ]
        },
        "p": {},
        "m": { "g": 1, "a": { "a": 0, "k": [0, 0], "ix": 2 } },
        "a": []
      },
      "ip": 0,
      "op": 36,
      "st": -9,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 13,
      "ty": 5,
      "nm": "N 2",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 5, "s": [0] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 12, "s": [100] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 28, "s": [100] },
            { "t": 33, "s": [0] }
          ],
          "ix": 11
        },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [157, 26.5, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "t": {
        "d": {
          "k": [
            {
              "s": { "s": 32, "f": "BodoniSvtyTwoITCTT-Book", "t": "N", "j": 2, "tr": 250, "lh": 38.4, "ls": 0, "fc": [0.067, 0.067, 0.067], "sc": [0.067, 0.067, 0.067], "sw": 0.5, "of": true },
              "t": 0
            }
          ]
        },
        "p": {},
        "m": { "g": 1, "a": { "a": 0, "k": [0, 0], "ix": 2 } },
        "a": []
      },
      "ip": 0,
      "op": 36,
      "st": -9,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 14,
      "ty": 5,
      "nm": "G 2",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 7, "s": [0] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 16, "s": [100] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 28, "s": [100] },
            { "t": 33, "s": [0] }
          ],
          "ix": 11
        },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [184.5, 26.5, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "t": {
        "d": {
          "k": [
            {
              "s": { "s": 32, "f": "BodoniSvtyTwoITCTT-Book", "t": "G", "j": 2, "tr": 250, "lh": 38.4, "ls": 0, "fc": [0.067, 0.067, 0.067], "sc": [0.067, 0.067, 0.067], "sw": 0.5, "of": true },
              "t": 0
            }
          ]
        },
        "p": {},
        "m": { "g": 1, "a": { "a": 0, "k": [0, 0], "ix": 2 } },
        "a": []
      },
      "ip": 0,
      "op": 36,
      "st": -9,
      "bm": 0
    }
  ],
  "markers": [],
  "chars": [
    {
      "ch": "G",
      "size": 32,
      "style": "Book",
      "w": 66.5,
      "data": {
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [1.333, 0],
                      [0.533, 0],
                      [0.466, 0],
                      [0, 0],
                      [1, 0.067],
                      [0, 0],
                      [0, -0.73],
                      [-0.267, -0.1],
                      [-0.934, 0],
                      [-0.634, -0.597],
                      [0, -3.317],
                      [1, -1.525],
                      [5.333, 0],
                      [4.1, 6.052],
                      [0, 10.297],
                      [-4.034, 6.219],
                      [-6.934, 0],
                      [-3.4, -3.716],
                      [-0.334, -6.495],
                      [-0.6, 0],
                      [-0.134, 1.6],
                      [0.066, 2.334],
                      [0, 0],
                      [-0.35, 3.8],
                      [0, 0.2],
                      [0.533, 0],
                      [0.333, -0.933],
                      [1.266, 0],
                      [1.533, 0.734],
                      [4.333, 0],
                      [6.066, -6.733],
                      [0, -10.933],
                      [-6.2, -6.3],
                      [-10.534, 0],
                      [-3.167, 1.192],
                      [-3.4, 2.92],
                      [0, 0],
                      [-0.267, 0.797],
                      [-3.067, -0.133],
                      [0, 0],
                      [0, 0.537]
                    ],
                    "o": [
                      [-0.2, 0],
                      [-0.534, 0],
                      [0, 0],
                      [-6.067, 0.067],
                      [0, 0],
                      [-1.467, 0],
                      [0, 0.331],
                      [0.266, 0.1],
                      [3.733, -0.066],
                      [0.633, 0.597],
                      [0, 3.983],
                      [-2, 3.053],
                      [-7, 0],
                      [-4.1, -6.05],
                      [0, -10.697],
                      [4.033, -6.219],
                      [5.533, 0],
                      [3.4, 3.717],
                      [0.066, 0.938],
                      [0.733, 0],
                      [0, 0.267],
                      [0, 0],
                      [0, -1.666],
                      [0.116, -1.2],
                      [0, -0.533],
                      [-0.467, 0],
                      [-0.4, 1.6],
                      [-1, 0],
                      [-5.134, -2.4],
                      [-9.934, 0],
                      [-6.067, 6.734],
                      [0, 10.8],
                      [6.2, 6.3],
                      [4.4, 0],
                      [3.166, -1.194],
                      [0, 0],
                      [0, -4.975],
                      [0.4, -1.194],
                      [0, 0],
                      [0.6, 0],
                      [0, -0.597]
                    ],
                    "v": [
                      [66.7, -21.9],
                      [65.6, -21.9],
                      [64.1, -21.9],
                      [55.7, -21.9],
                      [45.1, -21.9],
                      [43.3, -21.9],
                      [41.1, -20.805],
                      [41.5, -20.158],
                      [43.3, -20.009],
                      [49.85, -19.213],
                      [50.8, -13.341],
                      [49.3, -5.078],
                      [38.3, -0.5],
                      [21.65, -9.577],
                      [15.5, -34.098],
                      [21.55, -59.472],
                      [38, -68.8],
                      [51.4, -63.225],
                      [57, -47.906],
                      [58, -46.5],
                      [59.3, -48.9],
                      [59.2, -52],
                      [59.2, -58.5],
                      [59.725, -66.7],
                      [59.9, -68.8],
                      [59.1, -69.6],
                      [57.9, -68.2],
                      [55.4, -65.8],
                      [51.6, -66.9],
                      [37.4, -70.5],
                      [13.4, -60.4],
                      [4.3, -33.9],
                      [13.6, -8.25],
                      [38.7, 1.2],
                      [50.05, -0.591],
                      [59.9, -6.762],
                      [59.9, -9.948],
                      [60.3, -18.608],
                      [65.5, -20.2],
                      [67.8, -20.2],
                      [68.7, -21.005]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "G",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              }
            ],
            "nm": "G",
            "np": 3,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ]
      },
      "fFamily": "Bodoni 72"
    },
    {
      "ch": "N",
      "size": 32,
      "style": "Book",
      "w": 65.6,
      "data": {
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [1.466, 0],
                      [0, 0],
                      [1.066, 0],
                      [0.066, 0],
                      [1.066, 0],
                      [0.866, 0],
                      [0, 0],
                      [0, -0.666],
                      [-2.4, 0],
                      [-0.467, -0.233],
                      [-0.067, -0.433],
                      [0, -2.066],
                      [0, 0],
                      [0, 0],
                      [2.2, 0],
                      [0.2, 0],
                      [2.066, 0.134],
                      [1.333, 0],
                      [0, -0.631],
                      [-1.734, 0],
                      [-1.067, -0.667],
                      [0, -5.541],
                      [0, 0],
                      [0.633, -0.434],
                      [3.933, -0.066],
                      [0, -0.6],
                      [-1.534, 0],
                      [0, 0],
                      [-1.234, 0.133],
                      [0.066, 0],
                      [-1.067, -0.066],
                      [-0.6, 0],
                      [0, 0.667],
                      [0.875, 0],
                      [0.944, 0.234],
                      [0.067, 0.87],
                      [0, 0],
                      [-7.409, -10.916],
                      [0, 0],
                      [-0.4, 0],
                      [-0.067, 0.598],
                      [0, 3.528],
                      [0, 0],
                      [-0.2, 0.366],
                      [-1.067, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0.667]
                    ],
                    "o": [
                      [0, 0],
                      [-0.934, 0],
                      [-1.134, 0],
                      [-0.2, 0],
                      [-1, 0],
                      [0, 0],
                      [-1.6, 0],
                      [0, 0.6],
                      [2.733, 0],
                      [0.466, 0.234],
                      [0.066, 0.434],
                      [0, 0],
                      [0, 0],
                      [-2.067, 0.2],
                      [-1.667, 0.067],
                      [-0.134, 0],
                      [-2.067, -0.133],
                      [-1, 0],
                      [0, 0.703],
                      [2.733, 0],
                      [2.266, 1.403],
                      [0, 0],
                      [0, 2.403],
                      [-0.634, 0.434],
                      [-1.334, 0],
                      [0, 0.602],
                      [0, 0],
                      [2.533, 0],
                      [1.233, -0.133],
                      [1, 0],
                      [3.2, 0.2],
                      [1.733, 0],
                      [0, -0.533],
                      [-3.57, -0.066],
                      [-0.944, -0.234],
                      [0, 0],
                      [10.611, 16.341],
                      [0, 0],
                      [0.531, 0.736],
                      [0.331, 0],
                      [0.066, -0.598],
                      [0, 0],
                      [0, -1.863],
                      [0.2, -0.366],
                      [0, 0],
                      [0, 0],
                      [1.666, 0.067],
                      [0, -0.666]
                    ],
                    "v": [
                      [62.1, -69.5],
                      [59, -69.5],
                      [56, -69.5],
                      [54.2, -69.5],
                      [52.3, -69.5],
                      [49.5, -69.5],
                      [46, -69.5],
                      [43.6, -68.5],
                      [47.2, -67.6],
                      [52, -67.25],
                      [52.8, -66.25],
                      [52.9, -62.5],
                      [52.9, -18.003],
                      [18.4, -69.5],
                      [12, -69.2],
                      [9.2, -69.1],
                      [5.9, -69.3],
                      [0.8, -69.5],
                      [-0.7, -68.553],
                      [1.9, -67.5],
                      [7.6, -66.498],
                      [11, -56.083],
                      [11, -6.709],
                      [10.05, -2.453],
                      [3.2, -1.703],
                      [1.2, -0.802],
                      [3.5, 0.1],
                      [4.5, 0.1],
                      [10.15, -0.1],
                      [11.9, -0.3],
                      [15, -0.2],
                      [20.7, 0.1],
                      [23.3, -0.9],
                      [21.986, -1.7],
                      [15.216, -2.152],
                      [13.7, -3.808],
                      [13.7, -59.805],
                      [40.73, -18.92],
                      [53.508, -0.205],
                      [54.903, 0.9],
                      [55.5, 0.002],
                      [55.6, -6.189],
                      [55.6, -63.706],
                      [55.9, -67.05],
                      [57.8, -67.6],
                      [59.6, -67.6],
                      [61.8, -67.6],
                      [64.3, -68.5]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "N",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              }
            ],
            "nm": "N",
            "np": 3,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ]
      },
      "fFamily": "Bodoni 72"
    },
    {
      "ch": "I",
      "size": 32,
      "style": "Book",
      "w": 31.4,
      "data": {
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [0.733, 0],
                      [0.733, 0.734],
                      [0, 3.8],
                      [0, 0],
                      [-0.372, 0.534],
                      [-1.687, 0.067],
                      [0, 0.506],
                      [1.075, 0],
                      [0, 0],
                      [1.006, 0],
                      [0, 0],
                      [0, -0.528],
                      [-1.283, -0.058],
                      [-0.406, -0.669],
                      [0, -3.277],
                      [0, 0],
                      [0.466, -0.569],
                      [2.666, -0.066],
                      [0, -0.533],
                      [-0.867, 0],
                      [-0.867, 0.067],
                      [-1.667, 0],
                      [-0.4, -0.2],
                      [0, 0],
                      [0, 0.567]
                    ],
                    "o": [
                      [-3.6, -0.133],
                      [-0.334, -0.333],
                      [0, 0],
                      [0, -2.266],
                      [0.372, -0.533],
                      [2.969, -0.125],
                      [0, -0.569],
                      [0, 0],
                      [-2.889, -0.066],
                      [0, 0],
                      [-0.806, 0],
                      [0, 0.413],
                      [3.308, 0.134],
                      [0.337, 0.402],
                      [0, 0],
                      [0, 3.278],
                      [-0.467, 0.569],
                      [-1.734, 0.067],
                      [0, 0.6],
                      [1.8, 0],
                      [1.666, -0.133],
                      [8.666, 0],
                      [0, 0],
                      [0.8, 0],
                      [0, -0.566]
                    ],
                    "v": [
                      [27.7, -1.7],
                      [21.2, -3],
                      [20.7, -9.2],
                      [20.7, -62.6],
                      [21.256, -66.8],
                      [24.345, -67.7],
                      [28.8, -68.647],
                      [27.188, -69.5],
                      [23.358, -69.4],
                      [17.514, -69.5],
                      [3.909, -69.5],
                      [2.7, -68.706],
                      [4.623, -68],
                      [10.194, -66.797],
                      [10.7, -61.28],
                      [10.7, -8.52],
                      [10, -2.752],
                      [5.3, -1.8],
                      [2.7, -0.9],
                      [4, 0],
                      [8, -0.1],
                      [13, -0.3],
                      [26.6, 0],
                      [27.6, 0],
                      [28.8, -0.85]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "I",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              }
            ],
            "nm": "I",
            "np": 3,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ]
      },
      "fFamily": "Bodoni 72"
    },
    {
      "ch": "D",
      "size": 32,
      "style": "Book",
      "w": 71.6,
      "data": {
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [3.733, 5.917],
                      [6.066, 2.006],
                      [12, 0],
                      [0, 0],
                      [1.533, 0],
                      [-0.067, 0],
                      [0, -0.533],
                      [-1.534, 0],
                      [-0.5, -0.533],
                      [0, -3.266],
                      [0, 0],
                      [0.266, -0.466],
                      [2.733, 0],
                      [0, -0.6],
                      [-1.267, 0],
                      [-0.467, 0],
                      [0, 0],
                      [0, 0],
                      [-2.1, 0],
                      [-0.267, 0],
                      [-6, 4.814],
                      [0, 11.769]
                    ],
                    "o": [
                      [-3.734, -5.917],
                      [-5, -1.672],
                      [0, 0],
                      [-1.467, 0],
                      [-1.534, 0],
                      [-1.134, 0],
                      [0, 0.734],
                      [2.933, 0],
                      [0.5, 0.534],
                      [0, 0],
                      [0, 2.067],
                      [-0.667, 1],
                      [-2.134, 0],
                      [0, 0.667],
                      [0.533, 0],
                      [0, 0],
                      [0, 0],
                      [4, 0],
                      [2.1, 0],
                      [10.066, 0],
                      [8.2, -6.552],
                      [0, -7.688]
                    ],
                    "v": [
                      [61.9, -55.108],
                      [47.2, -66.992],
                      [21.7, -69.5],
                      [11, -69.5],
                      [6.5, -69.5],
                      [4.3, -69.5],
                      [2.6, -68.7],
                      [4.9, -67.6],
                      [10.05, -66.8],
                      [10.8, -61.1],
                      [10.8, -7.2],
                      [10.4, -3.4],
                      [5.3, -1.9],
                      [2.1, -1],
                      [4, 0],
                      [5.5, 0],
                      [13.4, 0],
                      [18.4, 0],
                      [27.55, 0],
                      [31.1, 0],
                      [55.2, -7.22],
                      [67.5, -34.7]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "D",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 1,
                "ty": "sh",
                "ix": 2,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [4.666, -5.35],
                      [7.2, 0],
                      [1.6, 0.803],
                      [0.1, 0.402],
                      [0, 1.872],
                      [0, 0],
                      [-0.4, 0.469],
                      [-4.467, 0],
                      [-4.334, -5.183],
                      [0, -11.1]
                    ],
                    "o": [
                      [-4.4, 5.083],
                      [-5.134, 0],
                      [-0.467, -0.267],
                      [-0.1, -0.402],
                      [0, 0],
                      [0, -2.741],
                      [0.933, -0.936],
                      [9.2, 0],
                      [4.333, 5.183],
                      [0, 11.569]
                    ],
                    "v": [
                      [49.3, -9.723],
                      [31.9, -2.1],
                      [21.8, -3.303],
                      [20.95, -4.306],
                      [20.8, -7.717],
                      [20.8, -61.081],
                      [21.4, -65.895],
                      [29.5, -67.3],
                      [49.8, -59.525],
                      [56.3, -35.102]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "D",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              }
            ],
            "nm": "D",
            "np": 5,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ]
      },
      "fFamily": "Bodoni 72"
    },
    {
      "ch": "A",
      "size": 32,
      "style": "Book",
      "w": 60.2,
      "data": {
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [1.733, 0.064],
                      [0.833, 0.413],
                      [0.533, 1.509],
                      [2.4, 6.467],
                      [0.866, 2.6],
                      [0.2, 0],
                      [0.2, -0.733],
                      [0, 0],
                      [0.155, -0.786],
                      [8.575, -24.616],
                      [0.933, -0.569],
                      [2.1, -0.066],
                      [0, -0.602],
                      [-0.933, 0],
                      [-0.533, 0.111],
                      [-1.067, 0],
                      [-1, -0.066],
                      [-3.067, 0],
                      [0, 0.667],
                      [1.933, 0.067],
                      [0.2, 0.067],
                      [0, 0.934],
                      [-3.997, 10.667],
                      [0, 0],
                      [-0.6, -2.069],
                      [0, 0],
                      [0, 0],
                      [0, -0.064],
                      [5.866, -0.066],
                      [0, -0.769],
                      [-1.334, 0],
                      [-0.467, 0.066],
                      [0, 0],
                      [0, 0],
                      [-0.667, 0],
                      [0, 0.569]
                    ],
                    "o": [
                      [-2.602, -0.069],
                      [-0.834, -0.411],
                      [-9.534, -26],
                      [-3.066, -8.266],
                      [-0.134, -0.4],
                      [-0.334, 0],
                      [0, 0],
                      [-0.466, 0.984],
                      [-5.384, 14.917],
                      [-0.534, 1.606],
                      [-0.934, 0.569],
                      [-2.1, 0.067],
                      [0, 0.603],
                      [0.334, 0],
                      [1, -0.222],
                      [1.066, 0],
                      [4.066, 0.266],
                      [1.733, 0],
                      [0, -0.6],
                      [-3.134, -0.2],
                      [-0.8, -0.2],
                      [0, -1.6],
                      [0, 0],
                      [2.331, 7.073],
                      [0, 0],
                      [0, 0],
                      [0.136, 0.458],
                      [0, 1.111],
                      [-1.8, 0],
                      [0, 0.698],
                      [0.533, 0],
                      [0, 0],
                      [0, 0],
                      [0.533, 0.066],
                      [1, 0],
                      [0, -0.567]
                    ],
                    "v": [
                      [62.1, -1.6],
                      [56.948, -2.32],
                      [54.898, -5.2],
                      [36.998, -53.9],
                      [31.1, -70.2],
                      [30.6, -70.8],
                      [29.8, -69.7],
                      [29.372, -67.875],
                      [28.441, -65.22],
                      [7.5, -5.92],
                      [5.3, -2.659],
                      [0.75, -1.706],
                      [-2.4, -0.703],
                      [-1, 0.2],
                      [0.3, 0.033],
                      [3.4, -0.3],
                      [6.5, -0.2],
                      [17.2, 0.2],
                      [19.8, -0.8],
                      [16.9, -1.8],
                      [11.9, -2.2],
                      [10.7, -3.9],
                      [16.694, -22.3],
                      [38.07, -22.3],
                      [42.466, -8.587],
                      [42.978, -7.192],
                      [43.795, -4.547],
                      [44, -3.764],
                      [35.2, -2],
                      [32.5, -0.847],
                      [34.5, 0.2],
                      [36, 0.1],
                      [48.7, -0.3],
                      [61.4, 0.1],
                      [63.2, 0.2],
                      [64.7, -0.653]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "A",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 1,
                "ty": "sh",
                "ix": 2,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [0, 0],
                      [-2.811, 7.377],
                      [0, 0],
                      [-1.086, -3]
                    ],
                    "o": [
                      [3.947, -11.8],
                      [0, 0],
                      [2.511, 6.936],
                      [0, 0]
                    ],
                    "v": [
                      [17.272, -24.6],
                      [27.409, -53.366],
                      [32.214, -39.505],
                      [37.609, -24.6]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "A",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              }
            ],
            "nm": "A",
            "np": 5,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ]
      },
      "fFamily": "Bodoni 72"
    },
    {
      "ch": "O",
      "size": 32,
      "style": "Book",
      "w": 72,
      "data": {
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [6, 6.934],
                      [8.866, 0],
                      [6.033, -6.633],
                      [0, -10.4],
                      [-6.267, -6.966],
                      [-9.2, 0],
                      [-5.967, 6.867],
                      [0, 9.934]
                    ],
                    "o": [
                      [-6, -6.933],
                      [-9.4, 0],
                      [-6.034, 6.634],
                      [0, 10.2],
                      [6.266, 6.967],
                      [8.666, 0],
                      [5.966, -6.866],
                      [0, -10.266]
                    ],
                    "v": [
                      [58.8, -60.1],
                      [36.5, -70.5],
                      [13.35, -60.55],
                      [4.3, -35],
                      [13.7, -9.25],
                      [36.9, 1.2],
                      [58.85, -9.1],
                      [67.8, -34.3]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "O",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 1,
                "ty": "sh",
                "ix": 2,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [3.533, -6.217],
                      [6.333, 0],
                      [3.766, 5.95],
                      [0, 10.766],
                      [-5.4, 6.019],
                      [-5.334, 0],
                      [-3.134, -4.278],
                      [0, -12.236]
                    ],
                    "o": [
                      [-3.2, 5.617],
                      [-6.8, 0],
                      [-3.767, -5.95],
                      [0, -13.572],
                      [2.933, -3.275],
                      [5.6, 0],
                      [5, 6.82],
                      [0, 10.364]
                    ],
                    "v": [
                      [51.3, -8.925],
                      [37, -0.5],
                      [21.15, -9.425],
                      [15.5, -34.5],
                      [23.6, -63.886],
                      [36, -68.8],
                      [49.1, -62.381],
                      [56.6, -33.797]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "O",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              }
            ],
            "nm": "O",
            "np": 5,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ]
      },
      "fFamily": "Bodoni 72"
    },
    {
      "ch": "L",
      "size": 32,
      "style": "Book",
      "w": 56.4,
      "data": {
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [0, 0],
                      [0, 0.467],
                      [0, 0.134],
                      [0, 0],
                      [0.833, 0],
                      [0.062, -0.866],
                      [1.133, -2.2],
                      [3.2, -0.8],
                      [7.8, 0],
                      [1.8, 0.067],
                      [0, 0],
                      [-0.367, 0.567],
                      [-1.934, 0.067],
                      [-0.367, 0.1],
                      [0, 0.4],
                      [1.2, 0],
                      [0, 0],
                      [1.733, -0.1],
                      [0.6, 0],
                      [2.2, 0.2],
                      [0, 0],
                      [0, -0.6],
                      [-1.267, 0],
                      [-0.5, -0.4],
                      [0, -2.466],
                      [0, 0],
                      [0.5, -0.433],
                      [2.533, -0.133],
                      [0, -0.466],
                      [-1.131, 0],
                      [0, 0],
                      [-1.531, -0.134],
                      [-0.4, 0],
                      [0, 0],
                      [0, 1.734]
                    ],
                    "o": [
                      [0, -0.466],
                      [0, -0.466],
                      [0, 0],
                      [0.066, -1],
                      [-0.703, 0],
                      [-0.2, 3.734],
                      [-1.134, 2.2],
                      [-3.2, 0.8],
                      [-3.2, 0],
                      [0, 0],
                      [0, -2.933],
                      [0.366, -0.566],
                      [1.933, -0.066],
                      [0.366, -0.1],
                      [0, -0.666],
                      [0, 0],
                      [-1.134, 0],
                      [-1.734, 0.1],
                      [-6.534, 0],
                      [0, 0],
                      [-0.8, 0],
                      [0, 0.734],
                      [3.066, 0],
                      [0.5, 0.4],
                      [0, 0],
                      [0, 2.067],
                      [-0.5, 0.434],
                      [-1.8, 0.134],
                      [0, 0.6],
                      [0, 0],
                      [1.928, 0],
                      [1.53, 0.133],
                      [0, 0],
                      [0.2, -4],
                      [0, 0]
                    ],
                    "v": [
                      [55.4, -11.8],
                      [55.4, -13.2],
                      [55.4, -14.1],
                      [55.4, -16.6],
                      [54.25, -18.1],
                      [53.1, -16.8],
                      [51.1, -7.9],
                      [44.6, -3.4],
                      [28.1, -2.2],
                      [20.6, -2.3],
                      [20.6, -61.3],
                      [21.15, -66.55],
                      [24.6, -67.5],
                      [28.05, -67.75],
                      [28.6, -68.5],
                      [26.8, -69.5],
                      [25.7, -69.5],
                      [21.4, -69.35],
                      [17.9, -69.2],
                      [4.8, -69.5],
                      [3.9, -69.5],
                      [2.7, -68.6],
                      [4.6, -67.5],
                      [9.95, -66.9],
                      [10.7, -62.6],
                      [10.7, -6.4],
                      [9.95, -2.65],
                      [5.4, -1.8],
                      [2.7, -0.9],
                      [4.397, 0],
                      [45.919, 0.3],
                      [51.108, 0.5],
                      [54.003, 0.7],
                      [55.1, 0.7],
                      [55.4, -7.9]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "L",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              }
            ],
            "nm": "L",
            "np": 3,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ]
      },
      "fFamily": "Bodoni 72"
    }
  ]
}
